import { Box } from '@mui/material'
import { Drawer, Loader } from 'packages/eid-ui'
import ItemHeader from '../ItemHeader'
import { isNilOrEmpty, useIsSmallScreen } from 'packages/core'
import ItemsDetailsMobileWrapper from 'components/ItemsDetailsMobileWrapper'
import SharedFolderDetails from './SharedFolderDetails'
import { useSharedFolder } from 'hooks'
import { catalogDetailsDrawerExplainProps } from '../catalogDetailsDrawerExplain'

const SharedFolderDrawer = ({ id, toggleDrawer, attributes }) => {
    const isSmallScreen = useIsSmallScreen()

    const { data: sharedFolder } = useSharedFolder(id)

    return isSmallScreen ? (
        <ItemsDetailsMobileWrapper toggleDrawer={toggleDrawer}>
            <Box {...catalogDetailsDrawerExplainProps('shared folder')}>
                <ItemHeader title={sharedFolder?.friendlyName} />
                {!sharedFolder && <Loader />}
                {sharedFolder && (
                    <SharedFolderDetails
                        sharedFolder={sharedFolder}
                        toggleDrawer={toggleDrawer}
                        attributes={attributes}
                    />
                )}
            </Box>
        </ItemsDetailsMobileWrapper>
    ) : (
        <Drawer
            width="clamp(67%, 1007px, 90%)"
            open={!isNilOrEmpty(id)}
            toggleDrawer={toggleDrawer}
            stickyHeader
            closeOnOutsideClick
            header={<ItemHeader title={sharedFolder?.friendlyName} />}
        >
            <Box {...catalogDetailsDrawerExplainProps('shared folder')}>
                {!sharedFolder && <Loader />}
                {sharedFolder && (
                    <SharedFolderDetails
                        sharedFolder={sharedFolder}
                        toggleDrawer={toggleDrawer}
                    />
                )}
            </Box>
        </Drawer>
    )
}

export default SharedFolderDrawer
